import React, { useContext } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import logo from '../common/assets/oyecreators-logo.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Drawer from '@mui/material/Drawer';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { WindowWidthContext } from './user-details-context';

const navItems = ['Blogs', 'Pricing'];


const CommonLandingPageAppBar = ({ handleDrawerToggle, mobileOpen, setMobileOpen }) => {
    const windowWidth = useContext(WindowWidthContext);
    const location = useLocation();
    const navigate = useNavigate();

    const darkTheme = createTheme({
        components: {
            MuiAppBar: {
                styleOverrides: {
                    root: {
                        backgroundColor: '#f4f0fa',
                        boxShadow: 'none',
                        position: 'relative',
                        height: '100px',
                        display:'flex',
                        justifyContent: 'center',
                    },
                },
            },
        },
    });

    const getRoutePath = (item) => {
        switch (item) {

            case 'Blogs':
                return '/blog';
            case 'Pricing':
                return '/pricing-page';
            default:
                return '/';
        }
    };

    const drawerWidth = 240;

    const drawer = (
        <Box onClick={() => setMobileOpen(false)} sx={{ textAlign: 'center' }}>
            <Typography variant="h6" sx={{ my: 3 }}>
                <Link to="/" aria-current="page" aria-label="home">
                    <img className="aaa-logo-landing-page" src={logo} alt="AAA logo" />
                </Link>
            </Typography>
            <Divider />
            <List>
                {navItems.map((item) => (
                    <ListItem key={item} disablePadding>
                        <ListItemButton onClick={() => {
                            setMobileOpen(false);
                            navigate(getRoutePath(item));
                        }}>
                            <ListItemText primary={item} />
                        </ListItemButton>
                    </ListItem>

                ))}
            </List>
            <Box sx={{ alignItems: 'center' }}>
                <div className="burger-menu-buttons">
                    <Link to="/ec/login" className="border border-primaryPink text-primaryPink">For Business</Link>
                    <Link to='/creators/signin' className="bg-primaryPink">For Creators</Link>

                </div>
            </Box>
        </Box>
    );

    return (
        <ThemeProvider theme={darkTheme}>
            <AppBar component="nav" className=''>
                <Toolbar className='flex items-center gap-64 pl-headerPaddingLeft' >
                    <Typography
                       className='pl-headerPaddingLeft'
                    >
                        <Link to="/" aria-current="page" aria-label="home">
                            <img className="w-40 h-24" src={logo} alt="AAA logo" />
                        </Link>
                    </Typography>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{ mr: 2, display: windowWidth <= 799 ? 'block' : 'none' }}
                    >
                        <MenuIcon sx={{ color: 'black' }} />
                    </IconButton>
                    {!location.pathname.includes('/ec') && (
                        <div sx={{ display: windowWidth <= 799 ? 'none' : 'flex', alignItems: 'center' }} className='flex gap-14'>
                            {navItems.map((item) => (
                                <div
                                    key={item}
                                    onClick={() => navigate(getRoutePath(item))}
                                    className="text-appbarTextColor capitalize mx-2 sm:mx-1 text-sm sm:text-lg lg:text-xl font-semibold  "

                                    // className='text-appbarTextColor'
                                    // sx={{
                                    //     color: '#56606E',
                                    //     textTransform: 'capitalize',
                                    //     mx: { xs: 2, sm: 1 },
                                    //     fontSize: { xs: '0.875rem', sm: '1.2rem',lg: '20px' },
                                    //     fontWeight: 600,
                                    //     color: '#7C63A9',

                                    // }}
                                >
                                    {item}
                                </div>
                            ))}
                        </div>
                    )}
                    {/* <div className="nav-items"> */}

                    <Box sx={{ display: windowWidth <= 799 ? 'none' : 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                        <div className="flex gap-12">
                            <Link to="/ec/login" className="border border-primaryPink text-primaryPink pt-2 pr-6 pb-2 pl-6 rounded-full text-sm	">For Business</Link>
                            <Link to='/creators/signin' className="bg-primaryPink pt-2 pr-6 pb-2 pl-6 rounded-full	text-sm">For Creators</Link>
                        </div>
                    </Box>
                    {/* </div> */}
                </Toolbar>
            </AppBar>
            <Drawer
                anchor="right"
                variant="temporary"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                ModalProps={{
                    keepMounted: true,
                }}
                sx={{
                    display: windowWidth <= 799 ? 'block' : 'none',
                    '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                }}
            >
                {drawer}
            </Drawer>
        </ThemeProvider>
    );
};


export default CommonLandingPageAppBar;